import Navigation from '../../../components/layout/Navigation';
import Footer from '../../../components/layout/Footer';
import Hero from '../../../components/ui/Hero';
import Section from '../../../components/ui/Section';
import FeatureGrid from '../../../components/ui/FeatureGrid';
import ProcessTimeline from '../../../components/ui/ProcessTimeline';
import CTA from '../../../components/ui/CTA';

export default function MarketingPage() {
  return (
    <div className="min-h-screen bg-black text-white">
      <Navigation />
      
      <Hero 
        title={<>Unlock Your Brand's <span className="bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent">Full Growth Potential</span></>}
        description="We transform data into decisive strategies, driving measurable and sustainable growth for your business."
        bgImage="/assets/modern-data-analytics-dashboard.png"
        primaryBtn={{ text: "Accelerate Growth", link: "/contact", icon: "ri-rocket-line" }}
        secondaryBtn={{ text: "Our Services", link: "#services", icon: "ri-eye-line" }}
      />

      <Section id="services">
        <FeatureGrid 
          title={<>Comprehensive Solutions for <span className="text-purple-400">Unmatched Performance</span></>}
          subtitle="Explore how our specialized services leverage data and intelligence to amplify your reach."
          items={[
            { title: 'AI Social Media', description: 'AI-driven content & automated scheduling.', icon: 'ri-share-line', color: 'from-purple-500 to-purple-600' },
            { title: 'Optimized PPC', description: 'Maximize ROI through continuous optimization.', icon: 'ri-target-line', color: 'from-purple-600 to-pink-500' },
            { title: 'AI Google Ads', description: 'Intelligent targeting & dynamic ad copy.', icon: 'ri-google-line', color: 'from-pink-500 to-pink-600' },
            { title: 'Data Analytics', description: 'Predictive insights & behavior analysis.', icon: 'ri-bar-chart-line', color: 'from-pink-600 to-purple-500' },
            { title: 'Content Production', description: 'SEO-friendly, impactful content creation.', icon: 'ri-edit-line', color: 'from-purple-500 to-pink-500' }
          ]}
        />
      </Section>

      <Section className="bg-gray-900">
        <ProcessTimeline 
          title="Data-Driven Precision for Real Impact"
          subtitle="We believe that true marketing excellence comes from understanding what works, why it works, and how to replicate success."
          steps={[
            { title: 'Collection', description: 'Gathering audience & market data.', icon: 'ri-database-line', color: 'from-purple-500 to-purple-600' },
            { title: 'Analysis', description: 'Deep dive into performance metrics.', icon: 'ri-search-line', color: 'from-purple-600 to-pink-500' },
            { title: 'Strategy', description: 'Building the growth roadmap.', icon: 'ri-lightbulb-line', color: 'from-pink-500 to-pink-600' },
            { title: 'Execution', description: 'Implementing targeted campaigns.', icon: 'ri-rocket-line', color: 'from-pink-600 to-purple-500' },
            { title: 'Optimization', description: 'Refining for better results.', icon: 'ri-settings-line', color: 'from-purple-500 to-purple-600' }
          ]}
        />
      </Section>

      <CTA 
        title={<>Transform Marketing into a <span className="bg-gradient-to-r from-purple-300 to-pink-300 bg-clip-text text-transparent">Growth Engine</span></>}
        description="Partner with Hash Adz to build a growth strategy that delivers clear, measurable results."
        primaryBtn={{ text: "Get Strategy", link: "/contact" }}
        secondaryBtn={{ text: "View Case Studies", link: "/work" }}
        stats={[
          { number: '300%', label: 'Avg ROI Increase' },
          { number: '150+', label: 'Campaigns' },
          { number: '98%', label: 'Satisfaction' }
        ]}
      />

      <Footer />
    </div>
  );
}